import { EditOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import {
  HistoryEntryV1OutputDto,
  QuarantineDefectOutputDto,
  RepairOutputDto,
} from 'generated/apiSchemas';

export const EditButton = ({
  historyEntry,
  isDefect,
  setCurrentDefect,
  setCurrentRepair,
  mobile,
}: {
  historyEntry: HistoryEntryV1OutputDto;
  isDefect: boolean;
  setCurrentDefect: (value: QuarantineDefectOutputDto | null) => void;
  setCurrentRepair: (value: RepairOutputDto | null) => void;
  mobile: boolean;
}) => {
  if (mobile) {
    return null;
  }

  return isDefect ? (
    <Button
      type="text"
      icon={<EditOutlined />}
      onClick={() => setCurrentDefect(historyEntry.quarantineDefect)}
    />
  ) : (
    <Button
      type="text"
      icon={<EditOutlined />}
      onClick={() =>
        setCurrentRepair(historyEntry.quarantineDefect?.repair ?? null)
      }
    />
  );
};
